import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
var OwningTeamConfirmationModal = function OwningTeamConfirmationModal(_ref) {
  var isMultiSelect = _ref.isMultiSelect,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel,
    disabled = _ref.disabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('actions_remove_owning_team'),
    body: /*#__PURE__*/React.createElement(React.Fragment, null, isMultiSelect ? /*#__PURE__*/React.createElement("p", null, t('modal_confirm_remove_owning_team_info_plural'), /*#__PURE__*/React.createElement("br", null), t('modal_confirm_remove_owning_team_admins_plural')) : /*#__PURE__*/React.createElement("p", null, t('modal_confirm_remove_owning_team_info'), /*#__PURE__*/React.createElement("br", null), t('modal_confirm_remove_owning_team_admins')), /*#__PURE__*/React.createElement("p", null, t('modal_confirm_remove_owning_team'))),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onCancel,
      isDisabled: disabled
    }, {
      label: t('actions_confirm'),
      onClick: onConfirm,
      variant: 'primary',
      isDisabled: disabled
    }],
    onClose: onCancel
  });
};
export default OwningTeamConfirmationModal;